import { connect } from 'react-redux';
import SearcherOperators from '../../components/Searcher/SearcherOperators';
import { getIsLoggedUser } from '../../store/selectors/user';
import { getMatchedOperators } from '../../store/selectors/operators';

const mapStateToProps = (state) => ({
  items: getIsLoggedUser(state) ? getMatchedOperators(state) : null,
});

export default connect(mapStateToProps)(SearcherOperators);
